import Chartkick from "chartkick";

// Chartkick destroys every chart on turbo:before-render so the outgoing page's
// Chart.js instances do not leak. That assumes the render replaces the body, and a
// redirect breaks the assumption. Turbo's followRedirect() starts a second visit with
// willRender: false to correct the URL. PageRenderer skips replaceBody() for that
// visit. Chartkick destroys the charts again and nothing rebuilds them, so the page
// keeps blank canvases.
//
// Destroy only the charts whose element left the document. A skipped body swap
// leaves every element connected, so those charts survive.
Chartkick.configure({ autoDestroy: false });

let outgoing = [];

document.addEventListener("turbo:before-render", () => {
  outgoing = Object.values(Chartkick.charts);
});

document.addEventListener("turbo:render", () => {
  outgoing.forEach((chart) => {
    const element = chart.getElement();
    if (element && element.isConnected) return;

    chart.destroy();
    // The new page reuses the same generated ids. Only drop the entry when it still
    // points at this chart.
    if (element && Chartkick.charts[element.id] === chart) {
      delete Chartkick.charts[element.id];
    }
  });

  outgoing = [];
});
